import React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbTableTHeadCell as ClbTableTHeadCell_ } from '@celebration/design-system/dist/lib/table-thead-cell';
const events = {
    onClbSortChange: ClbTableTHeadCell_.events
        .onClbSortChange,
};
export const ClbTableTHeadCell = createComponent({
    tagName: ClbTableTHeadCell_.tagName,
    elementClass: ClbTableTHeadCell_,
    react: React,
    events: events,
});
export const ClbTableTHeadCellSlots = ClbTableTHeadCell_.slots;
//# sourceMappingURL=index.js.map